import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((c) => {
  const t = localStorage.getItem("hm_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export const adminApi = axios.create({ baseURL: `${API}/admin` });
adminApi.interceptors.request.use((c) => {
  const t = localStorage.getItem("hm_admin");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
adminApi.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config.url.includes("/login")) {
      localStorage.removeItem("hm_admin");
      window.location.href = "/admin";
    }
    return Promise.reject(e);
  }
);

export const media = (p) => (!p ? "" : p.startsWith("http") || p.startsWith("/") ? p : `${API}/media/${p}`);
export const czk = (n) => `${Number(n || 0).toLocaleString("cs-CZ", { maximumFractionDigits: 2 })} Kč`;
export const priceTxt = (n) => (Number(n) > 0 ? czk(n) : "Zdarma");
export const effPrice = (p) => (p.sale_price && p.sale_price < p.price ? p.sale_price : p.price);
export const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("cs-CZ") : "–");
export const fmtSize = (b) => (!b ? "" : b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.round(b / 1024)} kB`);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Něco se pokazilo, zkuste to znovu.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export async function openBlob(client, url, filename, method = "get", body) {
  const r = method === "post" ? await client.post(url, body, { responseType: "blob" }) : await client.get(url, { responseType: "blob" });
  const href = URL.createObjectURL(r.data);
  if (filename) {
    const a = document.createElement("a");
    a.href = href;
    a.download = filename;
    a.click();
    setTimeout(() => URL.revokeObjectURL(href), 2000);
  }
  return href;
}

export const STATUS = {
  pending: { label: "Čeká na platbu", cls: "bg-[#FDF3D3] text-[#8a6a0a]" },
  paid: { label: "Zaplaceno", cls: "bg-[#E9EFE0] text-[#5d6845]" },
  cancelled: { label: "Zrušeno", cls: "bg-[#F8E1D7] text-[#a2482a]" },
};
